/**
 * Map of application hostnames to their API gateway URLs.
 * - apigwUrl: Server-side API gateway URL
 * - apigwBrowserUrl: Browser-facing API gateway URL (used for client-side requests)
 */
const HOST_TO_GATEWAY_MAP = {
    'us2.concursolutions.com': {
        apigwUrl: 'us2.api.concursolutions.com',
        apigwBrowserUrl: 'www-us2.api.concursolutions.com',
    },
    'integration.concursolutions.com': {
        apigwUrl: 'integration.api.concursolutions.com',
        apigwBrowserUrl: 'www-integration.api.concursolutions.com',
    },
    'eu2.concursolutions.com': {
        apigwUrl: 'eu2.api.concursolutions.com',
        apigwBrowserUrl: 'www-eu2.api.concursolutions.com',
    },
    'apj1.concursolutions.com': {
        apigwUrl: 'apj1.api.concursolutions.com',
        apigwBrowserUrl: 'www-us2.apj1.concursolutions.com',
    },
    'www.concurcdc.cn': {
        apigwUrl: 'cn.api.concurcdc.cn',
        apigwBrowserUrl: 'www-cn.api.concurcdc.cn',
    },
    'usg.concursolutions.com': {
        apigwUrl: 'usg.api.concursolutions.com',
        apigwBrowserUrl: 'www-usg.api.concursolutions.com',
    },
};

/**
 * Gets the API gateway URLs for the current hostname.
 *
 * @returns {{ apigwUrl: string, apigwBrowserUrl: string }} The API gateway URLs,
 *   or empty strings if not found
 */
export const getApiGatewayUrls = () => {
    const hostname = window?.location?.hostname;
    return HOST_TO_GATEWAY_MAP[hostname] || { apigwUrl: '', apigwBrowserUrl: '' };
};

/**
 * Fixes branding logo URLs that incorrectly use the server API gateway URL
 * instead of the browser-facing URL. Older versions of nui-shell may send
 * the wrong URL, so we correct it here to ensure compatibility.
 *
 * @param {string} url - The branding logo URL to fix
 * @returns {string} The corrected URL with the browser-facing API gateway host
 */
export const fixBrandingLogoUrl = (url) => {
    // Return falsy values unchanged, preserving the original type (null, undefined, '')
    if (!url) return url;

    const gwUrls = getApiGatewayUrls();
    if (!gwUrls.apigwUrl || !gwUrls.apigwBrowserUrl) return url;

    // Only replace if using server URL and NOT already using browser URL
    if (url.includes(gwUrls.apigwUrl) && !url.includes(gwUrls.apigwBrowserUrl)) {
        return url.replace(gwUrls.apigwUrl, gwUrls.apigwBrowserUrl);
    }

    return url;
};
